import { selectMissingRecipeCost } from "../../../../selectors/selectRecipeInfo";
export var checkHasEnoughResources = function (path) { return function (action, state$) {
    var state = state$.value;
    var missingResources = selectMissingRecipeCost(state, action.recipeId, action.amount);
    if (missingResources.length > 0) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/checks/checkHasEnoughResources.ts
// module id = 1934
// module chunks = 3